import { createFileRoute } from '@tanstack/react-router';
import { SystemsListPage } from '@/pages/organization/systems/SystemsListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/organization/systems/')({
  component: SystemsListPage,
  validateSearch: dataTableSearchSchema({})
});
